import { render, staticRenderFns } from "./subheader.vue?vue&type=template&id=528ed4d6&scoped=true&"
import script from "./subheader.vue?vue&type=script&lang=ts&"
export * from "./subheader.vue?vue&type=script&lang=ts&"
import style0 from "./subheader.vue?vue&type=style&index=0&id=528ed4d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528ed4d6",
  null
  
)

export default component.exports